<template>
  <!--
    Tela de cobranca da licenca, do DEV. Nao tem entrada no Menu.js e nao esta
    dentro do Layout: e rota irma de /login, entao nao passa por verificaRota()
    nem exige usuario do sistema. O unico controle e a SENHA_PG do .env da API,
    conferida no backend (nada de senha no bundle).
  -->
  <div class="pg-admin">
    <!-- ============ senha ============ -->
    <div v-if="!autenticado" class="caixa-senha">
      <h5>Acesso restrito</h5>
      <b-form @submit.prevent="entrar">
        <b-form-input
          v-model="senhaDigitada"
          type="password"
          placeholder="Senha"
          autocomplete="off"
          v-focus
        />
        <b-button
          type="submit"
          variant="dark"
          class="mt-2 w-100"
          :disabled="entrando"
        >
          {{ entrando ? "Verificando..." : "Entrar" }}
        </b-button>
      </b-form>
      <div v-if="erroLogin" class="erro">{{ erroLogin }}</div>
    </div>

    <!-- ============ painel ============ -->
    <div v-else class="painel">
      <header>
        <h5>Cobrança da licença</h5>
        <span class="estado" :class="statusAtual.estado">
          {{ statusAtual.estado }}
        </span>
      </header>

      <p v-if="statusAtual.estado !== 'OK'" class="previa">
        <strong>Prévia do que o cliente vê:</strong><br />
        {{ statusAtual.mensagem }}
      </p>

      <b-tabs content-class="mt-3" small>
        <!-- ---------- configuracao ---------- -->
        <b-tab title="Configuração" active>
          <div class="grade">
            <label class="check">
              <b-form-checkbox v-model="form.ativo" switch>
                Cobrança ativa
              </b-form-checkbox>
              <small>Desligado, nenhum usuário vê aviso algum.</small>
            </label>

            <label>
              Primeira competência
              <b-form-input v-model="form.competencia_inicial" type="month" />
              <small>Mês da primeira parcela (AAAA-MM).</small>
            </label>

            <label>
              Dia do vencimento
              <b-form-input
                v-model="form.dia_vencimento"
                type="number"
                min="1"
                max="31"
              />
              <small>
                Em meses mais curtos cai no último dia (31 → 28/02).
                <strong>Mudar aqui move o vencimento das parcelas ainda em aberto.</strong>
              </small>
            </label>

            <label>
              Valor da parcela
              <b-form-input v-model="form.valor" placeholder="199,90" />
            </label>

            <label>
              Avisar quantos dias antes
              <b-form-input
                v-model="form.dias_aviso_antes"
                type="number"
                min="0"
                max="60"
              />
              <small>Depois do vencimento o aviso continua até ser pago.</small>
            </label>

            <label class="check">
              <b-form-checkbox v-model="form.block_ativo" switch>
                BLOCK — bloquear lançamentos
              </b-form-checkbox>
              <small>
                Recusa gravação de pedido, mesa, caixa, contas a pagar e
                bancário. Leitura e relatórios continuam.
              </small>
            </label>

            <label>
              Bloquear após quantos dias de atraso
              <b-form-input
                v-model="form.block_dias"
                type="number"
                min="0"
                placeholder="vazio = nunca"
              />
              <small>Em branco nunca bloqueia, mesmo com o BLOCK ligado.</small>
            </label>
          </div>

          <div class="preview-datas" v-if="proximas.length">
            <strong>Próximos vencimentos com essa regra:</strong>
            <span v-for="p in proximas" :key="p.competencia">
              {{ p.competencia }} → {{ dataBr(p.vencimento) }}
            </span>
          </div>
        </b-tab>

        <!-- ---------- mensagem ---------- -->
        <b-tab title="Mensagem e Pix">
          <label class="bloco">
            Título
            <b-form-input v-model="form.titulo" placeholder="Mensalidade do sistema" />
          </label>

          <label class="bloco">
            Mensagem antes de vencer
            <b-form-textarea v-model="form.mensagem_lembrete" rows="3" />
          </label>

          <label class="bloco">
            Mensagem depois de vencer
            <b-form-textarea v-model="form.mensagem_vencido" rows="3" />
          </label>

          <div class="vars">
            Variáveis:
            <code v-for="v in variaveis" :key="v" @click="copiar(v)">{{ v }}</code>
          </div>

          <label class="bloco">
            Pix copia e cola
            <b-form-textarea
              v-model="form.pix_copia_cola"
              rows="3"
              placeholder="00020126..."
            />
            <small>O QR Code é gerado a partir deste código.</small>
          </label>

          <div v-if="form.pix_copia_cola" class="qr">
            <vue-qrcode
              :value="form.pix_copia_cola"
              type="image/png"
              :width="160"
              :margin="2"
              :errorCorrectionLevel="'M'"
            />
            <small>Confira lendo com o celular antes de salvar.</small>
          </div>
        </b-tab>

        <!-- ---------- parcelas ---------- -->
        <b-tab title="Parcelas">
          <p v-if="!calendario.length" class="vazio">
            Defina a primeira competência e salve para ver as parcelas.
          </p>
          <table v-else class="parcelas">
            <thead>
              <tr>
                <th>Competência</th>
                <th>Vence</th>
                <th>Situação</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="c in calendarioInvertido" :key="c.competencia">
                <td>{{ c.competencia }}</td>
                <td>{{ dataBr(c.vencimento) }}</td>
                <td>
                  <span v-if="c.pagamento" class="pago">
                    pago em {{ dataBr(c.pagamento.dt_pagamento) }}
                  </span>
                  <span v-else class="aberto">em aberto</span>
                </td>
                <td class="acao">
                  <b-button
                    v-if="!c.pagamento"
                    size="sm"
                    variant="success"
                    :disabled="salvando"
                    @click="marcarPago(c)"
                  >
                    Marcar pago
                  </b-button>
                  <b-button
                    v-else
                    size="sm"
                    variant="outline-danger"
                    :disabled="salvando"
                    @click="desfazer(c)"
                  >
                    Desfazer
                  </b-button>
                </td>
              </tr>
            </tbody>
          </table>
        </b-tab>
      </b-tabs>

      <footer>
        <small v-if="avisoCache">
          O aviso nos navegadores pode levar até 1 minuto para refletir.
        </small>
        <b-button variant="dark" :disabled="salvando" @click="salvar">
          {{ salvando ? "Salvando..." : "Salvar configuração" }}
        </b-button>
      </footer>
    </div>
  </div>
</template>

<script>
import VueQrcode from "vue-qrcode";
import PgLib from "@/libs/PgLib";

const VARIAVEIS = [
  "{valor}",
  "{valor_parcela}",
  "{qtd_parcelas}",
  "{vencimento}",
  "{dias_atraso}",
  "{dias_para_vencer}",
];

export default {
  name: "PgAdmin",
  components: { VueQrcode },

  data() {
    return {
      // Só em memória: um F5 pede a senha de novo. E uma tela usada uma vez por
      // mes — nao vale o risco de deixar a senha em storage.
      senha: "",
      senhaDigitada: "",
      autenticado: false,
      entrando: false,
      erroLogin: "",
      salvando: false,
      avisoCache: false,
      variaveis: VARIAVEIS,
      form: {
        ativo: false,
        competencia_inicial: "",
        dia_vencimento: "",
        valor: "",
        dias_aviso_antes: 5,
        block_ativo: false,
        block_dias: "",
        titulo: "",
        mensagem_lembrete: "",
        mensagem_vencido: "",
        pix_copia_cola: "",
      },
      calendario: [],
      statusAtual: { estado: "OK" },
    };
  },

  computed: {
    calendarioInvertido() {
      return this.calendario.slice().reverse();
    },
    proximas() {
      return this.calendario.slice(-3);
    },
  },

  created() {
    // store.state.loading nasce true e o overlay do App.vue tem z-index 9999;
    // como esta rota nao passa por verificaRota(), ninguem desligaria.
    this.$store.state.loading = false;
  },

  methods: {
    dataBr(iso) {
      if (!iso) return "-";
      const p = String(iso).split("-");
      return p.length === 3 ? p[2] + "/" + p[1] + "/" + p[0] : iso;
    },

    mensagemDeErro(err) {
      const status = err && err.response && err.response.status;
      if (status === 404) return "Senha inválida.";
      if (status === 429) return "Muitas tentativas. Aguarde alguns minutos.";
      const dados = err && err.response && err.response.data;
      return (dados && dados.message) || "Falha ao comunicar com a API.";
    },

    async entrar() {
      this.entrando = true;
      this.erroLogin = "";
      try {
        await PgLib.login(this.senhaDigitada);
        this.senha = this.senhaDigitada;
        this.senhaDigitada = "";
        this.autenticado = true;
        await this.carregar();
      } catch (err) {
        this.erroLogin = this.mensagemDeErro(err);
      }
      this.entrando = false;
    },

    aplicar(dados) {
      const c = dados.config || {};
      this.form = {
        ativo: !!c.ativo,
        competencia_inicial: c.competencia_inicial || "",
        dia_vencimento: c.dia_vencimento === null ? "" : c.dia_vencimento,
        valor: c.valor === null || c.valor === undefined ? "" : String(c.valor),
        dias_aviso_antes: c.dias_aviso_antes === null ? 5 : c.dias_aviso_antes,
        block_ativo: !!c.block_ativo,
        // NULL e "nunca bloqueia". Nao pode virar 0 na volta pelo formulario.
        block_dias: c.block_dias === null || c.block_dias === undefined ? "" : c.block_dias,
        titulo: c.titulo || "",
        mensagem_lembrete: c.mensagem_lembrete || "",
        mensagem_vencido: c.mensagem_vencido || "",
        pix_copia_cola: c.pix_copia_cola || "",
      };
      this.calendario = dados.calendario || [];
      this.statusAtual = dados.status || { estado: "OK" };
    },

    async carregar() {
      try {
        const res = await PgLib.getConfig(this.senha);
        this.aplicar(res.data);
      } catch (err) {
        this.showToast("error", this.mensagemDeErro(err));
      }
    },

    async salvar() {
      this.salvando = true;
      try {
        const res = await PgLib.storeConfig(this.senha, this.form);
        this.aplicar(res.data);
        this.avisoCache = true;
        this.showToast("success", "Configuração salva.");
      } catch (err) {
        this.showToast("error", this.mensagemDeErro(err));
      }
      this.salvando = false;
    },

    async marcarPago(c) {
      this.salvando = true;
      try {
        const res = await PgLib.pagar(this.senha, { competencia: c.competencia });
        this.aplicar(res.data);
        this.avisoCache = true;
        this.showToast("success", c.competencia + " marcada como paga.");
      } catch (err) {
        this.showToast("error", this.mensagemDeErro(err));
      }
      this.salvando = false;
    },

    async desfazer(c) {
      this.salvando = true;
      try {
        const res = await PgLib.desfazerPagamento(this.senha, c.competencia);
        this.aplicar(res.data);
        this.avisoCache = true;
        this.showToast("success", "Pagamento de " + c.competencia + " desfeito.");
      } catch (err) {
        this.showToast("error", this.mensagemDeErro(err));
      }
      this.salvando = false;
    },

    copiar(texto) {
      const area = document.createElement("textarea");
      area.value = texto;
      area.style.position = "fixed";
      area.style.opacity = "0";
      document.body.appendChild(area);
      area.select();
      document.execCommand("copy");
      document.body.removeChild(area);
      this.showToast("success", texto + " copiado");
    },
  },
};
</script>

<style lang="scss" scoped>
.pg-admin {
  min-height: 100vh;
  background: #18181b;
  padding: 24px 12px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  text-align: left;
}

.caixa-senha {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  width: 100%;
  max-width: 320px;
  margin-top: 12vh;

  h5 {
    margin-bottom: 16px;
  }
}

.erro {
  color: #c1121f;
  font-size: 13px;
  margin-top: 10px;
}

.painel {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  width: 100%;
  max-width: 760px;

  header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;

    h5 {
      margin: 0;
    }
  }

  footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 18px;
    border-top: 1px solid #eee;
    padding-top: 14px;

    small {
      color: #8a6100;
    }
  }
}

.estado {
  font-size: 11px;
  font-weight: 700;
  padding: 3px 10px;
  border-radius: 20px;
  background: #e6f4ea;
  color: #1e7b34;

  &.LEMBRETE {
    background: #fff8e1;
    color: #8a6100;
  }
  &.VENCIDO {
    background: #fdecec;
    color: #a4161a;
  }
  &.BLOQUEADO {
    background: #a4161a;
    color: #fff;
  }
}

.previa {
  background: #f6f6f7;
  border-left: 4px solid #c1121f;
  padding: 10px 12px;
  border-radius: 6px;
  font-size: 13px;
  white-space: pre-wrap;
}

.grade {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
  gap: 14px;
}

label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  width: 100%;

  small {
    display: block;
    font-weight: 400;
    color: #666;
    margin-top: 4px;
  }

  &.bloco {
    margin-bottom: 14px;
  }

  &.check {
    align-self: end;
  }
}

.preview-datas {
  margin-top: 16px;
  font-size: 12px;
  color: #444;

  span {
    display: inline-block;
    background: #f1f1f3;
    border-radius: 6px;
    padding: 2px 8px;
    margin: 4px 6px 0 0;
  }
}

.vars {
  font-size: 12px;
  margin-bottom: 14px;

  code {
    cursor: pointer;
    background: #f1f1f3;
    border-radius: 4px;
    padding: 2px 6px;
    margin-right: 5px;
  }
}

.qr {
  text-align: center;
  margin-bottom: 10px;

  small {
    display: block;
    color: #666;
  }
}

.parcelas {
  width: 100%;
  font-size: 13px;

  th,
  td {
    padding: 6px 8px;
    border-bottom: 1px solid #eee;
  }

  th {
    font-size: 11px;
    text-transform: uppercase;
    color: #666;
  }

  .pago {
    color: #1e7b34;
  }
  .aberto {
    color: #a4161a;
    font-weight: 600;
  }
  .acao {
    text-align: right;
  }
}

.vazio {
  color: #666;
  font-size: 13px;
}
</style>
